import moment from "moment";

export const formatDate = (date: string | null | undefined): string | null => {
	if (!date) {
		return null;
	}
	const daysDiff = moment(date).startOf("day").diff(moment().startOf("day"), "days");
	if (daysDiff < 0) {
		return moment(date).format("MMM D");
	}
	if (daysDiff == 0) {
		if (moment(date).format("m") == "0") {
			return moment(date).format("h a");
		}
		return moment(date).format("h:mm a");
	}
	if (daysDiff < 7) {
		return moment(date).format("ddd");
	}
	return moment(date).format("MMM D");
};
